<template>
    <div style="padding: 20px;">
        <el-row style="text-align: center;">
            <span style="font-size: 24px;">{{title}}</span>
        </el-row>
        <el-row style="text-align: right;">
            <span style="font-size: 10px;">{{createTime}}</span>
        </el-row>
        <el-row>
            <div v-html="content"></div>
        </el-row>
    </div>
</template>

<script>
import {getArticleById,articlesSingleToken,getArticleProjects} from '@/api/file'
export default {
    name: '',
    data(){
        return {
            id:'',
            type: '',
            title:'',
            createTime: null,
            content: '',
            token: ''
        }
    },
    methods:{
        getArcicle(){
            if(this.id===undefined) {
                // return this.$message.error('id错误')
                // 认为是单页文章
                articlesSingleToken(this.type,this.token).then(response => {
                    if(response.code!=200)  return this.$message.error('获取单文章失败！')
                    //console.log(response)
                    this.content=response.data.content
                    this.title=response.data.title
                    this.createTime=response.data.createTime
                })
            }else if(this.type==='gcal') {
                getArticleProjects(this.id,this.token).then(response => {
                    console.log(response)
                    if(response.code!=200)  return this.$message.error('获取工程案例文章失败！')
                    //console.log(response)
                    this.content=response.data.content
                    this.title=response.data.title
                    this.createTime=response.data.createTime
                })
            }else{
                getArticleById(this.id,this.type,this.token).then(response => {
                    console.log(response)
                    if(response.code!=200)  return this.$message.error('获取文章失败！')
                    //console.log(response)
                    this.content=response.data.content
                    this.title=response.data.title
                    this.createTime=response.data.createTime
                })
            }

        },
        isMobile() {
            if (/phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)) {
                // this.mbSelect()
            } else {
                // this.pcSelect()
            }
            /*this.mbSelect()
            手机端要执行的方法
            this.pcSelect()
            pc端要执行的方法*/
        }
    },
    created(){
        this.isMobile()
        //console.log(this.$route)
        this.id=this.$route.query.id
        this.type=this.$route.query.type
        this.token=this.$route.query.token
        this.getArcicle()
    }
}
</script>

<style scoped>

</style>
